import styled from 'styled-components'
import { themeMedia } from '../../../styles/theme'
import { brandConfig } from '../../../config/brandConfig'

export const StyledWrapper = styled.div`
  padding-top: 40px;
`

export const StyledRow = styled.div`
  display: flex;
  flex-direction: column;
  font-size: ${brandConfig.fonts.text.paragraph.size.desktop};

  ${themeMedia.desktop`
    flex-direction: row;
  `};
`

export const StyledCol = styled.div`
  flex: 1 1 100%;
  width: 100%;
  line-height: 26px;

  ${themeMedia.desktop`
    flex: 1 1 50%;
    width: 50%;
  `};
`

export const StyledInfoTextWrapper = styled.div`
  padding: 1rem 0;
  padding-top: 2rem;
  font-size: ${brandConfig.fonts.text.paragraph.size.desktop};
`
